<template lang="pug">
include /mixins

container(space="md", align="left")
  row(
    appearance="spaced"
    class="tg-chat-navigation-row"
  )
    //- секция менеджеров. видна только админу
    cell(
      v-if="shouldShowManagersSection"
      :cols="['12']"
      class="tg-unidentified-cell tg-chat-navigation-cell tg-chat-navigation-cell--managers"
      :class="{ 'is-collapsed': isDesktopStepCollapsed('managers'), 'is-expanded': !isDesktopStepCollapsed('managers') }"
    )
      button.tg-chat-navigation-rail(
        v-if="isDesktopStepCollapsed('managers')"
        type="button"
        :title="_('Back to managers')"
        @click.prevent="goToManagers"
      )
        span.tg-chat-navigation-rail__arrow ←
        icon.tg-chat-navigation-rail__icon(name="people", size="lg")
        span.tg-chat-navigation-rail__label {{ _('Managers') }}

      form-fieldset(
        v-if="!isDesktopStepCollapsed('managers')"
        :caption="_('Managers')"
        icon="people"
      )
        +b.tg-unidentified-pane
          loading-wrapper(:loading="isManagersLoading" size="2xl")
            template(v-if="managerList.length")
              +b.tg-unidentified-list
                ds-panel(
                  v-for="manager in managerList"
                  :key="manager.id"
                  space="sm"
                  class="tg-unidentified-list-item-panel"
                ): ds-panel-element(offset="vertical")
                  ds-link(
                    appearance="block"
                    class="tg-unidentified-list-item"
                    :class="{'is-active': selectedManager && selectedManager.id === manager.id, 'is-telegram-disconnected': isManagerTelegramDisconnected(manager)}"
                    @click.prevent="selectManager(manager)"
                  )
                    .tg-unidentified-manager__header
                      ds-caption(variant="strong") {{ getManagerTitle(manager) }}
                      span.tg-unidentified-manager__status(
                        v-if="isManagerTelegramDisconnected(manager)"
                      ) {{ _('Disconnected') }}
                    ds-caption(size="sm") {{ getManagerSubtitle(manager) }}
                    ds-caption(
                      v-if="getManagerTelegramUsername(manager)"
                      size="sm"
                    ) {{ getManagerTelegramUsername(manager) }}
                    ds-caption(
                      v-if="getManagerTelegramPhone(manager)"
                      size="sm"
                    ) {{ getManagerTelegramPhone(manager) }}

            template(v-else)
              ds-panel: ds-panel-element(offset="vertical")
                ds-caption(size="sm") {{ _('No managers with Telegram accounts found.') }}

    //- секция списка неидентифицированных чатов
    //- Для админа зависит от выбранного менеджера
    //- Для менеджера показывает его собственные unidentified-чаты
    cell(
      v-if="shouldShowChatsSection"
      :cols="['12']"
      class="tg-unidentified-cell tg-chat-navigation-cell tg-chat-navigation-cell--chats"
      :class="{ 'is-collapsed': isDesktopStepCollapsed('chats'), 'is-expanded': !isDesktopStepCollapsed('chats') }"
    )
      button.tg-chat-navigation-rail(
        v-if="isDesktopStepCollapsed('chats')"
        type="button"
        :title="_('Назад к чатам')"
        @click.prevent="goToChats"
      )
        span.tg-chat-navigation-rail__arrow ←
        icon.tg-chat-navigation-rail__icon(name="telegram", size="lg")
        span.tg-chat-navigation-rail__label {{ _('Chats') }}

      form-fieldset(
        v-if="!isDesktopStepCollapsed('chats')"
        :caption="_('Chats')"
        icon="telegram"
      )
        +b.tg-unidentified-pane
          //- даём возврат к списку менеджеров
          +b.tg-unidentified-mobile-actions(v-if="isAdminView")
            control-button.tg-unidentified-back-button(
              styling="primary"
              @click.prevent="goToManagers"
            ) {{ _('Back to managers') }}

            ds-caption(
              v-if="selectedManager"
              size="sm"
            ) {{ getManagerTitle(selectedManager) }}

          loading-wrapper(:loading="isChatsLoading" size="2xl")
            template(v-if="canLoadChats && chatList.length")
              +b.tg-unidentified-list.tg-unidentified-chat-list(
                ref="chatsScroll"
                @scroll.passive="handleChatsScroll"
              )
                ds-panel(
                  v-for="chat in chatList"
                  :key="chat.id"
                  space="sm"
                  :class="{ 'is-actions-open': actionsChatId === chat.id }"
                ): ds-panel-element(offset="vertical")
                  +b.tg-unidentified-list-item(
                    :class="{ 'is-active': activeChat && activeChat.id === chat.id }"
                    @click="selectChat(chat)"
                  )
                    +b.tg-unidentified-chat-item__header
                      ds-caption(variant="strong") {{ getChatTitle(chat) }}

                      .tg-chat-card-header-actions
                        span(
                          v-if="getChatUnreadCount(chat)"
                          class="tg-unidentified-unread-badge"
                        ) {{ getChatUnreadCount(chat) }}

                        span.tg-chat-card-actions-toggle(
                          v-if="!identified || isAdminView"
                          role="button"
                          tabindex="0"
                          @click.prevent.stop="toggleChatActions(chat)"
                          @keydown.enter.prevent.stop="toggleChatActions(chat)"
                        ) ⋮

                    //- Telegram info
                    .tg-unidentified-chat-item__meta
                      ds-caption(size="sm") {{ getChatDetails(chat) }}

                    template(v-if="identified")
                      .tg-unidentified-chat-item__meta(
                        v-if="getChatClients(chat).length"
                      )
                        ds-caption(size="sm")
                          span.tg-unidentified-chat-item__meta-label
                            | {{ _('Clients') }}:

                        .tg-unidentified-chat-item__owners
                          template(
                            v-for="client in getChatClients(chat)"
                          )
                            ds-link(
                              :key="`client-${client.id}`"
                              tag="router-link"
                              :to="getClientRoute(client)"
                              @click.stop
                            ) {{ getChatOwnerTitle(client) }}

                      .tg-unidentified-chat-item__meta(
                        v-if="getChatLeads(chat).length"
                      )
                        ds-caption(size="sm")
                          span.tg-unidentified-chat-item__meta-label
                            | {{ _('Leads') }}:

                        .tg-unidentified-chat-item__owners
                          template(
                            v-for="lead in getChatLeads(chat)"
                          )
                            ds-link(
                              :key="`lead-${lead.id}`"
                              tag="router-link"
                              :to="getLeadRoute(lead)"
                              @click.stop
                            ) {{ getChatOwnerTitle(lead) }}

                    .tg-unidentified-chat-item__meta(
                      v-if="getChatLastMessageAt(chat)"
                    )
                      ds-caption(size="sm")
                        span.tg-unidentified-chat-item__meta-label
                          | {{ _('Последнее сообщение') }}:
                        |  {{ getChatLastMessageAt(chat) }}

                    +b.tg-chat-card-actions-popover(
                      v-if="actionsChatId === chat.id"
                      @click.stop
                    )
                      template(v-if="!identified")
                        control-button(
                          styling="primary"
                          size="sm"
                          @click.prevent.stop="openIdentifyModal(chat, 'lead')"
                        ) {{ isGroupChat(chat) ? _('Привязать к лиду') : _('Создать лида') }}

                        control-button(
                          styling="primary"
                          size="sm"
                          @click.prevent.stop="openIdentifyModal(chat, 'client')"
                        ) {{ isGroupChat(chat) ? _('Привязать к клиенту') : _('Создать клиента') }}

                      template(v-else-if="isAdminView")
                        control-button(
                          styling="primary"
                          size="sm"
                          @click.prevent.stop="openAddOwnersModal(chat)"
                        ) {{ _('Добавить') }}

                        control-button(
                          styling="primary"
                          size="sm"
                          @click.prevent.stop="openRelinkChatModal(chat)"
                        ) {{ _('Переподвязать') }}

                        control-button(
                          styling="primary"
                          size="sm"
                          @click.prevent.stop="openUnlinkOwnerModal(chat)"
                        ) {{ _('Отвязать') }}

                        control-button(
                          styling="primary"
                          size="sm"
                          @click.prevent.stop="openUnlinkAllChatModal(chat)"
                        ) {{ _('Отвязать всех') }}
                  ds-caption.tg-chat-list-loading-more(
                    v-if="isLoadingMoreChats"
                    size="sm"
                  ) {{ _('Загрузка чатов...') }}

            template(v-else-if="!canLoadChats")
              ds-panel: ds-panel-element(offset="vertical")
                ds-caption(size="sm") {{ selectManagerEmptyStateMessage }}

            template(v-else)
              ds-panel: ds-panel-element(offset="vertical")
                ds-caption(size="sm") {{ chatsEmptyStateMessage }}

    //- отдельный навигационный уровень Telegram forum topics.
    cell(
      v-if="shouldShowTopicsSection"
      :cols="['12']"
      class="tg-unidentified-cell tg-chat-navigation-cell tg-chat-navigation-cell--topics"
      :class="{ 'is-collapsed': isDesktopStepCollapsed('topics'), 'is-expanded': !isDesktopStepCollapsed('topics') }"
    )
      button.tg-chat-navigation-rail(
        v-if="isDesktopStepCollapsed('topics')"
        type="button"
        :title="_('Назад к топикам')"
        @click.prevent="goToTopics"
      )
        span.tg-chat-navigation-rail__arrow ←
        icon.tg-chat-navigation-rail__icon(name="chat", size="lg")
        span.tg-chat-navigation-rail__label {{ _('Топики') }}

      form-fieldset(
        v-if="!isDesktopStepCollapsed('topics')"
        :caption="_('Топики')"
        icon="chat"
      )
        +b.tg-unidentified-pane
          +b.tg-unidentified-mobile-actions
            control-button.tg-unidentified-back-button(
              styling="default"
              @click.prevent="goToChats"
            ) {{ _('Назад к чатам') }}

            ds-caption(
              v-if="activeChat"
              size="sm"
            ) {{ getChatTitle(activeChat) }}

          telegram-chat-topics(
            :chat="activeChat"
            :active-topic="activeTopic"
            @select="selectTopic"
          )

    //- секция активного чата
    cell(
      v-if="shouldShowMessagesSection"
      :cols="['12']"
      class="tg-unidentified-cell tg-chat-navigation-cell tg-chat-navigation-cell--messages is-expanded"
    )
      form-fieldset(:caption="_('Chat')", icon="chat")
        +b.tg-unidentified-pane
          //- возврат к списку чатов.
          +b.tg-unidentified-mobile-actions
            control-button.tg-unidentified-back-button(
              styling="default"
              @click.prevent="goBackFromMessages"
            ) {{ messagesBackButtonTitle }}

            ds-caption(
              v-if="activeChat"
              size="sm"
            ) {{ getChatTitle(activeChat) }}

          template(
            v-if="activeChat && (!activeChatIsForum || activeTopic)"
          )
            telegram-chat-conversation(
              :key="`${activeChat.id}-${activeTopic ? activeTopic.id : 'chat'}`"
              :chat="activeChat"
              :topic="activeChatIsForum ? activeTopic : null"
              :title="activeChatIsForum && activeTopic ? getTopicTitle(activeTopic) : getChatTitle(activeChat)"
              :subtitle="activeChatIsForum ? getChatTitle(activeChat) : getChatDetails(activeChat)"
              :can-send-message="canSendMessage"
              :is-refresh-disabled="isChatsLoading"
              :empty-state-message="conversationEmptyStateMessage"
              :messages-empty-state-message="messagesEmptyStateMessage"
              :unread-count="activeChatIsForum ? 0 : activeChatUnreadCount"
              @seen="handleConversationSeen"
              @refresh-list="receiveChats"
            )

          template(v-else-if="activeChatIsForum")
            ds-panel
              ds-panel-element(offset="vertical")
                ds-caption(size="sm")
                  | {{ _('Выберите топик, чтобы открыть сообщения.') }}

          template(v-else)
            ds-panel
              ds-panel-element(offset="vertical")
                ds-caption(size="sm")
                  | {{ _('Выберите чат, чтобы открыть сообщения.') }}

</template>

<script>
import { mapState } from 'vuex'
import { hasAccess } from '@aspectus/permissions'
import { toBeSuperuser } from '@md/users/permissions'
import { tgChatApi } from '@md/tg-chat/api'
import { simplifiers, filterAPIMiddleware } from '@md/ui/filter'
import { composeTransformers } from '@md/transformers'
import TelegramChatConversation from '@sections/cabinet/modules/tg-chats/components/TelegramChatConversation'
import TelegramChatIdentifyModal from '@sections/cabinet/modules/tg-chats/components/TelegramChatIdentifyModal'
import TelegramChatRelinkModal from '@sections/cabinet/modules/tg-chats/components/TelegramChatRelinkModal'
import TelegramChatUnlinkConfirmModal from '@sections/cabinet/modules/tg-chats/components/TelegramChatUnlinkConfirmModal'
import TelegramChatAddOwnersModal from '@sections/cabinet/modules/tg-chats/components/TelegramChatAddOwnersModal'
import TelegramChatTopics from '@sections/cabinet/modules/tg-chats/components/TelegramChatTopics'
import { prefixLanguage } from '@md/urls'
import {
  EDIT as EDIT_CLIENT,
} from '@sections/cabinet/modules/clients/views/navigation'
import {
  EDIT as EDIT_LEAD,
} from '@sections/cabinet/modules/leads/views/navigation'

const filtersToAPITransformer = composeTransformers(
  simplifiers.same('profile__type'),
  simplifiers.same('is_active'),
  simplifiers.same('has_telegram_account'),
);
const filterMiddleware = filterAPIMiddleware(filtersToAPITransformer);

export default {
  EDIT_CLIENT,
  EDIT_LEAD,
  props: {
    identified: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSuperuser: false,
      isManagersLoading: false,
      isChatsLoading: false,
      managerList: [],
      selectedManager: null,
      chatList: [],
      activeChat: null,
      activeTopic: null,
      // id чата, для которого сейчас открыт popover с actions
      actionsChatId: null,
      // состояние мобильного step-flow
      isMobileView: false,
      mobileStep: 'chats',
      desktopStep: 'managers',
      chatsScrollTop: 0,
      mobileMediaQuery: null,
      mobileMediaQueryListener: null,
      isLoadingMoreChats: false,
      chatsPageSize: 30,
      chatsOffset: 0,
      hasMoreChats: false,
      chatsRequestVersion: 0,
    }
  },
  components: {
    TelegramChatConversation,
    TelegramChatTopics,
  },
  computed: {
    ...mapState('users/auth', ['user']),

    isAdminView() {
      return this.isSuperuser
    },

    currentUserInfo() {
      return this.user && this.user.info
        ? this.user.info
        : null
    },

    canLoadChats() {
      if (!this.isAdminView) {
        return true
      }

      return !!(this.selectedManager && this.selectedManager.id)
    },

    // TelegramAccount текущего пользователя
    // Для менеджера отправка идёт через его собственный TelegramAccount
    currentUserTelegramAccount() {
      return this.currentUserInfo && this.currentUserInfo.telegramAccount
        ? this.currentUserInfo.telegramAccount
        : null
    },

    // аккаунт, через который разрешена отправка
    // Для админа используем TelegramAccount выбранного менеджера чата
    sendingTelegramAccount() {
      if (
        this.isAdminView
        && this.activeChat
        && this.activeChat.manager
        && this.activeChat.manager.telegramAccount
      ) {
        return this.activeChat.manager.telegramAccount
      }

      if (
        this.isAdminView
        && this.selectedManager
        && this.selectedManager.telegramAccount
      ) {
        return this.selectedManager.telegramAccount
      }

      return this.currentUserTelegramAccount
    },

    // отправка доступна только если выбран чат
    // и есть TelegramAccount, через который можно отправлять
    canSendMessage() {
      return !!(
        this.activeChat
        && this.activeChat.id
        && this.sendingTelegramAccount
      )
    },
    conversationEmptyStateMessage() {
      return this._('Select a chat to view messages.')
    },
    messagesEmptyStateMessage() {
      if (!this.activeChat) {
        return this.conversationEmptyStateMessage
      }

      return this._('There are no messages in this chat yet.')
    },
    activeChatUnreadCount() {
      if (!this.activeChat) {
        return 0
      }

      return this.getChatUnreadCount(this.activeChat)
    },

    shouldShowManagersSection() {
      return this.isAdminView && (
        !this.isMobileView || this.mobileStep === 'managers'
      )
    },

    shouldShowChatsSection() {
      if (this.isMobileView) {
        return this.mobileStep === 'chats'
      }

      return !this.isAdminView || (
        this.desktopStep !== 'managers' && this.canLoadChats
      )
    },

    shouldShowMessagesSection() {
      if (this.isMobileView) {
        return this.mobileStep === 'messages'
      }

      return this.desktopStep === 'messages' && !!this.activeChat
    },

    selectManagerEmptyStateMessage() {
      return this.identified
        ? this._('Select a manager to see identified chats.')
        : this._('Select a manager to see unidentified chats.')
    },

    chatsEmptyStateMessage() {
      return this.identified
        ? this._('No identified Telegram chats found.')
        : this._('No unidentified Telegram chats found.')
    },

    activeChatIsForum() {
      return !!(
        this.activeChat
        && this.isForumChat(this.activeChat)
      )
    },

    topicsCellCols() {
      return this.isAdminView
        ? ['12', '2-xl']
        : ['12', '3-xl']
    },

    messagesCellCols() {
      if (this.activeChatIsForum) {
        return this.isAdminView
          ? ['12', '5-xl']
          : ['12', '6-xl']
      }

      return this.isAdminView
        ? ['12', '7-xl']
        : ['12', '9-xl']
    },

    shouldShowTopicsSection() {
      if (!this.activeChatIsForum) {
        return false
      }

      if (this.isMobileView) {
        return this.mobileStep === 'topics'
      }

      return ['topics', 'messages'].includes(this.desktopStep)
    },

    messagesBackButtonTitle() {
      return this.activeChatIsForum
        ? this._('Назад к топикам')
        : this._('Назад к чатам')
    },
  
  },
  // при переключении Unidentified / Identified Vue может переиспользовать
  // тот же экземпляр компонента, поэтому mounted повторно не вызывается.
  // Явно сбрасываем выбранный чат и перечитываем список с новым identified.
  watch: {
    identified: {
      async handler(newValue, oldValue) {
        if (newValue === oldValue) {
          return
        }

        this.activeChat = null
        this.activeTopic = null
        this.chatList = []
        this.chatsScrollTop = 0
        this.closeChatActions()

        if (this.isAdminView) {
          const hasSelectedManager = !!(
            this.selectedManager && this.selectedManager.id
          )

          this.desktopStep = hasSelectedManager
            ? 'chats'
            : 'managers'

          this.mobileStep = hasSelectedManager
            ? 'chats'
            : 'managers'
        } else {
          this.desktopStep = 'chats'
          this.mobileStep = 'chats'
        }

        await this.receiveChats()
      },
    },
  },
  async mounted() {
    document.addEventListener('click', this.closeChatActions)

    this.initMobileView()

    await this.setAccessSuperuser([toBeSuperuser])
    await this.ensureCurrentUserLoaded()

    this.setInitialMobileStep()
    // У обычного менеджера нет уровня Managers.
    // Сразу открываем полноценную колонку собственных чатов.
    if (!this.isAdminView) {
      this.desktopStep = 'chats'
    }

    if (this.isAdminView) {
      await this.receiveManagers()
      return
    }

    await this.receiveChats()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeChatActions)
    this.destroyMobileView()
  },
  methods: {
    async setAccessSuperuser(permissions) {
      await hasAccess(permissions || [], this)
        .then(() => {
          this.isSuperuser = true
        })
        .catch(() => {
          this.isSuperuser = false
        })
    },

    async ensureCurrentUserLoaded() {
      if (!(this.user && this.user.determined)) {
        try {
          await this.$store.dispatch('users/auth/initialReceive')
        } catch (error) {
          // Ошибку не пробрасываем, чтобы страница чатов не падала целиком
        }
      }
    },

    // Содержимое предыдущих колонок скрываем,
    // но сами компоненты и их состояние сохраняем.
    isDesktopStepCollapsed(step) {
      return !this.isMobileView && this.desktopStep !== step
    },

    // добавляем Client/Lead к уже существующим связям чата.
    openAddOwnersModal(chat) {
      this.closeChatActions()
      if (
        !this.isAdminView
        || !(chat && chat.id)
      ) {
        return
      }

      this.$modal.show(
        TelegramChatAddOwnersModal,
        {
          chat,
          promise: () => this.receiveChats(),
        },
        {
          height: 'auto',
          adaptive: true,
          scrollable: true,
        }
      )
    },

    openUnlinkAllChatModal(chat) {
      this.closeChatActions()
      if (
        !this.isAdminView
        || !(chat && chat.id)
      ) {
        return
      }

      this.$modal.show(
        TelegramChatUnlinkConfirmModal,
        {
          title: this._('Отвязать чат Telegram от всех контактов?'),
          description: this._(
            'Все клиенты и лиды будут отвязаны от этого чата в Telegram. Чат станет неидентифицированным.'
          ),
          confirmTitle: this._('Отвязать всех'),
          promise: () => this.unlinkChatAll(chat),
        },
        {
          height: 'auto',
          adaptive: true,
          scrollable: true,
        }
      )
    },

    async unlinkChatAll(chat) {
      await tgChatApi.chat.unlink.execute(
        {
          chatId: chat.id,
        },
        {}
      )

      this.$toast.success(
        this._('Все клиенты и лиды успешно отвязаны от Telegram-чата.')
      )

      if (
        this.activeChat
        && this.activeChat.id === chat.id
      ) {
        this.activeChat = null
      }

      await this.receiveChats()
    },

    extractListItems(response) {
      // TODO оставить один, фактический
      if (Array.isArray(response)) {
        return response
      }
      if (Array.isArray(response?.data?.items)) {
        return response.data.items
      }
      if (Array.isArray(response?.items)) {
        return response.items
      }
      if (Array.isArray(response?.results)) {
        return response.results
      }

      return []
    },

    extractChatsPage(response) {
      const variants = [
        response?.data?.item,
        response?.item,
        response?.data,
        response,
      ]

      for (const result of variants) {
        if (!result) {
          continue
        }

        const items = Array.isArray(result.results)
          ? result.results
          : (Array.isArray(result.items) ? result.items : null)

        if (!items) {
          continue
        }

        const totalValue = (
          result.pagination?.total
          ?? result.pagination?.count
          ?? result.count
          ?? result.total
        )

        const total = (
          totalValue !== undefined
          && totalValue !== null
          && Number.isFinite(Number(totalValue))
        ) ? Number(totalValue) : null

        return {
          items,
          count: total,
          hasNext: Boolean(
            result.next || result.pagination?.next
          ),
        }
      }

      return {
        items: [],
        count: 0,
        hasNext: false,
      }
    },

    handleChatsScroll(event) {
      this.chatsScrollTop = event.target.scrollTop
      const list = event.target

      if (
        list.scrollTop + list.clientHeight
        >= list.scrollHeight - 120
      ) {
        this.receiveChats({ append: true })
      }
    },

    // Если 30 карточек не заполнили высоту скролла,
    // догружаем дальше, пока появится прокрутка или
    // закончатся записи.
    loadMoreChatsIfListIsShort() {
      const list = this.$refs.chatsScroll

      if (
        list
        && this.hasMoreChats
        && !this.isChatsLoading
        && !this.isLoadingMoreChats
        && list.scrollHeight <= list.clientHeight + 20
      ) {
        this.receiveChats({ append: true })
      }
    },

    async receiveManagers() {
      console.log('receiveManagers')
      this.isManagersLoading = true

      try {
        // Нужны только сотрудники с verified TelegramAccount
        // TODO и это должны быть только менеджеры! (пока что)
        const parameters = {
          filters: {
            is_active: true,
            has_telegram_account: true,
            profile__type: ['0001000-manager',]
          },
          limit: 99,
        };
        console.log('parameters', parameters)
        const response = await this.$api.staff.list.middleware(filterMiddleware).execute(
          parameters
        )
        console.log('response', response)

        this.managerList = this.extractListItems(response)

        // if (this.managerList.length) {
        //   this.selectedManager = this.managerList[0]
        //   await this.receiveChats()
        // }
        // Админ сначала видит расширенный список менеджеров.
        // Чаты открываются только после выбора менеджера.
        this.selectedManager = null
        this.desktopStep = 'managers'
      } catch (error) {
        this.managerList = []
        this.selectedManager = null
        this.chatList = []
        this.activeChat = null
      } finally {
        this.isManagersLoading = false
      }
    },

    async selectManager(manager) {
      const sameManager = !!(
        this.selectedManager
        && this.selectedManager.id === manager.id
      )

      this.selectedManager = manager
      this.closeChatActions()
      this.goToChats()

      // При повторном выборе менеджера не сбрасываем
      // уже загруженные 30/60/90... чатов.
      if (sameManager) {
        return
      }

      this.activeChat = null
      this.activeTopic = null

      await this.receiveChats()
    },

    async receiveChats({ append = false } = {}) {
      if (!this.canLoadChats) {
        this.chatsRequestVersion += 1
        this.chatList = []
        this.activeChat = null
        this.activeTopic = null
        this.chatsOffset = 0
        this.hasMoreChats = false
        this.isChatsLoading = false
        this.isLoadingMoreChats = false
        return
      }

      if (append) {
        if (
          this.isChatsLoading
          || this.isLoadingMoreChats
          || !this.hasMoreChats
        ) {
          return
        }

        this.isLoadingMoreChats = true
      } else {
        this.chatsRequestVersion += 1
        this.isChatsLoading = true
        this.isLoadingMoreChats = false
        this.chatList = []
        this.chatsOffset = 0
        this.chatsScrollTop = 0
        this.hasMoreChats = false
        this.closeChatActions()
      }

      const version = this.chatsRequestVersion
      const offset = append ? this.chatsOffset : 0

      try {
        const params = {
          identified: this.identified ? 1 : 0,
          limit: this.chatsPageSize,
          offset,
        }

        if (
          this.isAdminView
          && this.selectedManager
          && this.selectedManager.id
        ) {
          params.managerId = this.selectedManager.id
        }

        const response = await tgChatApi.list.execute(params)

        // Ответ от предыдущего manager/tab уже неактуален.
        if (version !== this.chatsRequestVersion) {
          return
        }

        const page = this.extractChatsPage(response)

        const knownIds = new Set(
          append ? this.chatList.map(chat => chat.id) : []
        )

        const additionalChats = page.items.filter(
          chat => !knownIds.has(chat.id)
        )

        this.chatList = append
          ? [...this.chatList, ...additionalChats]
          : page.items

        // Offset учитывает количество строк в ответе сервера,
        // а не количество уникальных карточек во frontend.
        this.chatsOffset = offset + page.items.length

        this.hasMoreChats = page.items.length > 0 && (
          page.count !== null
            ? this.chatsOffset < page.count
            : page.hasNext
        )

        if (this.activeChat) {
          const updatedChat = this.chatList.find(
            chat => chat.id === this.activeChat.id
          )

          if (updatedChat) {
            this.activeChat = updatedChat
          } else if (!this.hasMoreChats) {
            this.activeChat = null
            this.activeTopic = null
          }
        }
      } catch (error) {
        if (version !== this.chatsRequestVersion) {
          return
        }

        if (!append) {
          this.chatList = []
          this.activeChat = null
          this.activeTopic = null
          this.chatsOffset = 0
          this.hasMoreChats = false
        } else {
          this.$toast.error(
            this._('Не удалось загрузить следующие чаты.')
          )
        }
      } finally {
        if (version === this.chatsRequestVersion) {
          this.isChatsLoading = false
          this.isLoadingMoreChats = false

          this.$nextTick(() => {
            const list = this.$refs.chatsScroll

            if (list && !append) {
              list.scrollTop = 0
            }

            this.loadMoreChatsIfListIsShort()
          })
        }
      }
    },

    selectChat(chat) {
      this.closeChatActions()
      this.activeChat = chat
      this.activeTopic = null

      if (this.isForumChat(chat)) {
        this.goToTopics()
      } else {
        this.goToMessages()
      }
    },

    selectTopic(topic) {
      this.activeTopic = topic
      this.goToMessages()
    },

    getTopicTitle(topic) {
      return (
        topic?.title
        || `${this._('Топик')} #${topic?.tgTopicId || topic?.tg_topic_id || topic?.id}`
      )
    },

    goBackFromMessages() {
      if (this.activeChatIsForum) {
        this.goToTopics()
        return
      }

      this.goToChats()
    },

    getManagerTitle(manager) {
      return (
        manager?.displayName
        || manager?.profile?.displayName
        || manager?.email
        || manager?.username
        || this._('Manager')
      )
    },

    getManagerSubtitle(manager) {
      return (
        manager?.objId
        || manager?.profile?.objId
        || manager?.email
        || ''
      )
    },

    getManagerTelegramAccount(manager) {
      return (
        manager?.telegramAccount
        || manager?.telegram_account
        || null
      );
    },

    getManagerTelegramUsername(manager) {
      const account = this.getManagerTelegramAccount(manager);
      const username = account?.username || '';

      if (!username) {
        return '';
      }

      return username.startsWith('@')
        ? username
        : `@${username}`;
    },

    getManagerTelegramPhone(manager) {
      const account = this.getManagerTelegramAccount(manager);

      return account?.phone || '';
    },

    getChatLastMessageAt(chat) {
      const value = (
        chat?.lastMessageAt
        || chat?.last_message_at
      );

      if (!value) {
        return '';
      }

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return value;
      }

      return new Intl.DateTimeFormat(
        undefined,
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        }
      ).format(date);
    },

    getChatClients(chat) {
      return Array.isArray(chat?.clients)
        ? chat.clients
        : []
    },

    getChatLeads(chat) {
      return Array.isArray(chat?.leads)
        ? chat.leads
        : []
    },

    // список всех текущих владельцев чата для выборочного unlink.
    getChatOwnerOptions(chat) {
      return [
        ...this.getChatClients(chat).map(client => ({
          ...client,
          _telegramOwnerType: 'client',
          _telegramOwnerKey: `client-${client.id}`,
          _telegramOwnerTitle: `${this._('Клиент')}: ${this.getChatOwnerTitle(client)}`,
        })),

        ...this.getChatLeads(chat).map(lead => ({
          ...lead,
          _telegramOwnerType: 'lead',
          _telegramOwnerKey: `lead-${lead.id}`,
          _telegramOwnerTitle: `${this._('Лид')}: ${this.getChatOwnerTitle(lead)}`,
        })),
      ]
    },

    getClientRoute(client) {
      return {
        name: this.$options.EDIT_CLIENT,
        params: {
          id: client.id,
        },
      }
    },

    getLeadRoute(lead) {
      return {
        name: this.$options.EDIT_LEAD,
        params: {
          id: lead.id,
        },
      }
    },

    getChatOwnerTitle(owner) {
      if (!owner) {
        return ''
      }

      const fullName = [
        owner.name,
        owner.middleName || owner.middle_name,
        owner.surname,
      ].filter(Boolean).join(' ')

      return (
        owner.displayName
        || owner.display_name
        || owner.title
        || fullName
        || owner.objId
        || owner.obj_id
        || owner.email
        || `#${owner.id}`
      )
    },

    // красное состояние показываем только если backend
    // явно сообщил isVerified=false, а не при отсутствии поля.
    isManagerTelegramDisconnected(manager) {
      const account = this.getManagerTelegramAccount(manager);

      if (!account) {
        return false;
      }

      return (
        account.isVerified === false
        || account.is_verified === false
      );
    },

    // тип Telegram-чата нужен для минимального отображения
    // обычных групп и supergroup
    getChatType(chat) {
      return (
        chat?.chatType
        || chat?.chat_type
        || 'private'
      )
    },

    isGroupChat(chat) {
      return [
        'group',
        'supergroup',
      ].includes(this.getChatType(chat))
    },

    isForumChat(chat) {
      return (
        this.getChatType(chat) === 'supergroup'
        && (
          chat?.isForum === true
          || chat?.is_forum === true
        )
      )
    },

    getChatTypeTitle(chat) {
      if (!this.isGroupChat(chat)) {
        return ''
      }

      if (this.isForumChat(chat)) {
        return this._('Форумная группа')
      }

      if (this.getChatType(chat) === 'supergroup') {
        return this._('Супергруппа')
      }

      return this._('Группа')
    },

    getChatTitle(chat) {
      if (this.isGroupChat(chat)) {
        return (
          chat?.title
          || chat?.username
          || this._('Группа Telegram')
        )
      }

      const fullName = [
        chat?.firstName,
        chat?.lastName,
      ].filter(Boolean).join(' ')

      return (
        fullName
        || chat?.username
        || this._('Telegram user')
      )
    },

    getChatTelegramId(chat) {
      if (!chat?.tgUserId) {
        return ''
      }

      return `${this._('Telegram ID')}: ${chat.tgUserId}`
    },

    getChatUsername(chat) {
      if (!chat?.username) {
        return ''
      }

      return `@${chat.username}`
    },

    getChatPhone(chat) {
      if (!chat?.phone) {
        return ''
      }

      return chat.phone
    },

    getChatDetails(chat) {
      return [
        this.getChatTypeTitle(chat),
        this.getChatTelegramId(chat),
        this.getChatUsername(chat),
        this.getChatPhone(chat),
      ].filter(Boolean).join(' • ')
    },

    getChatUnreadCount(chat) {
      const value = Number(chat?.tgUnreadCount || chat?.unreadCount || 0)

      if (!Number.isFinite(value) || value < 0) {
        return 0
      }

      return value
    },

    // conversation-компонент сообщает
    // что сообщения активного чата были открыты/прочитаны
    // Parent локально обнуляет unread в списке unidentified-чатов
    handleConversationSeen() {
      this.markActiveChatUnreadLocallyAsSeen()
    },

    // локально обнуляем unread у выбранного unidentified-чата
    // чтобы бейдж исчез без полной перезагрузки страницы
    markActiveChatUnreadLocallyAsSeen() {
      if (!(this.activeChat && this.activeChat.id)) {
        return
      }

      this.chatList = this.chatList.map(chat => {
        if (chat.id !== this.activeChat.id) {
          return chat
        }

        return {
          ...chat,
          tgUnreadCount: 0,
          unreadCount: 0,
        }
      })

      this.activeChat = this.chatList.find(
        chat => chat.id === this.activeChat.id
      ) || this.activeChat
    },

    async unlinkChatOwner(chat, owner) {
      if (
        !(chat && chat.id)
        || !owner
      ) {
        return
      }

      const payload = owner._telegramOwnerType === 'lead'
        ? {
          lead: owner.id,
        }
        : {
          user: owner.id,
        }

      await tgChatApi.chat.unlink.execute(
        {
          chatId: chat.id,
        },
        payload
      )

      this.$toast.success(
        this._('Контакт успешно отвязан от Telegram-чата.')
      )

      // Если у чата остались другие владельцы -
      // он останется в Identified и просто обновится.
      // Если удалили последнего - receiveChats уберёт его из списка.
      await this.receiveChats()
    },

    // выборочно отвязываем одного Client/Lead,
    // остальные связи Telegram-чата сохраняются.
    openUnlinkOwnerModal(chat) {
      this.closeChatActions()
      if (
        !this.isAdminView
        || !(chat && chat.id)
      ) {
        return
      }

      const ownerOptions = this.getChatOwnerOptions(chat)

      if (!ownerOptions.length) {
        return
      }

      this.$modal.show(
        TelegramChatUnlinkConfirmModal,
        {
          title: this._('Отвязать контакт от чата?'),
          description: this._(
            'Будет удалена только выбранная связь. Остальные клиенты и лиды останутся привязаны к этому чату.'
          ),
          confirmTitle: this._('Отвязать'),
          ownerOptions,
          promise: owner => this.unlinkChatOwner(chat, owner),
        },
        {
          height: 'auto',
          adaptive: true,
          scrollable: true,
        }
      )
    },

    // открываем модалку создания/привязки лида или клиента.
    // Attach работает сразу через LinkClientAPIView.
    // Create редиректит на существующую страницу создания с query из чата.
    openIdentifyModal(chat, mode) {
      this.closeChatActions()
      const pr = arg => new Promise((resolve, reject) => {
        if (arg) {
          resolve(arg)
          return
        }

        reject(arg)
      }).then(() => {
        this.activeChat = null
        this.receiveChats()
      })

      this.$modal.show(
        TelegramChatIdentifyModal,
        {
          chat,
          mode,
          createRoute: this.getCreateRouteFromChat(chat, mode),
          promise: pr,
        },
        {
          height: 'auto',
          adaptive: true,
          scrollable: true,
        }
      )
    },

    // привязка unidentified-чата к существующему Client/Lead.
    // Используем тот же admin link endpoint, что и для перепривязки identified-чата.
    openRelinkChatModal(chat) {
      this.closeChatActions()
      if (
        !this.isAdminView
        || !(chat && chat.id)
      ) {
        return
      }

      const pr = arg => new Promise((resolve, reject) => {
        if (arg) {
          resolve(arg)
          return
        }

        reject(arg)
      }).then(() => {
        this.activeChat = null
        this.receiveChats()
      })

      this.$modal.show(
        TelegramChatRelinkModal,
        {
          chat,
          promise: pr,
        },
        {
          height: 'auto',
          adaptive: true,
          scrollable: true,
        }
      )
    },

    // готовим route на существующие страницы создания
    // Данные передаём через query, чтобы они переживали обычный path-based переход
    getCreateRouteFromChat(chat, mode) {
      return {
        path: mode === 'lead'
          ? prefixLanguage('/cabinet/leads/create/')
          : prefixLanguage('/cabinet/clients/create/'),
        query: this.getCreateQueryFromChat(chat),
      }
    },

    // query-параметры для предзаполнения формы создания лида/клиента
    getCreateQueryFromChat(chat) {
      return {
        tg_chat_source: 'unidentified',
        tg_chat_id: chat?.id || '',
        tg_user_id: chat?.tgUserId || chat?.tg_user_id || '',
        tg_username: chat?.username || '',
        tg_phone: chat?.phone || '',
        tg_first_name: chat?.firstName || chat?.first_name || '',
        tg_last_name: chat?.lastName || chat?.last_name || '',
        tg_manager_id: chat?.manager?.id || this.selectedManager?.id || '',
        tg_manager_title:
          chat?.manager?.displayName
          || chat?.manager?.display_name
          || chat?.manager?.email
          || '',
      }
    },
    // включаем mobile step-flow на ширинах ниже xl
    initMobileView() {
      if (typeof window === 'undefined' || !window.matchMedia) {
        return
      }

      this.mobileMediaQuery = window.matchMedia('(max-width: 1199px)')
      this.isMobileView = this.mobileMediaQuery.matches

      const listener = event => {
        this.isMobileView = event.matches
        this.setInitialMobileStep()
        if (!this.isAdminView) {
          this.desktopStep = 'chats'
        }
      }

      this.mobileMediaQueryListener = listener

      if (typeof this.mobileMediaQuery.addEventListener === 'function') {
        this.mobileMediaQuery.addEventListener('change', listener)
        return
      }

      this.mobileMediaQuery.addListener(listener)
    },

    destroyMobileView() {
      if (!this.mobileMediaQuery || !this.mobileMediaQueryListener) {
        return
      }

      if (typeof this.mobileMediaQuery.removeEventListener === 'function') {
        this.mobileMediaQuery.removeEventListener('change', this.mobileMediaQueryListener)
        return
      }

      this.mobileMediaQuery.removeListener(this.mobileMediaQueryListener)
    },

    setInitialMobileStep() {
      if (!this.isMobileView) {
        return
      }

      this.mobileStep = this.isAdminView
        ? 'managers'
        : 'chats'
    },

    toggleChatActions(chat) {
      if (!(chat && chat.id)) {
        return
      }

      this.actionsChatId = (
        this.actionsChatId === chat.id
          ? null
          : chat.id
      )
    },

    closeChatActions() {
      this.actionsChatId = null
    },

    goToManagers() {
      if (!this.isAdminView) {
        return
      }

      this.mobileStep = 'managers'
      this.desktopStep = 'managers'
    },

    goToChats() {
      this.mobileStep = 'chats'
      this.desktopStep = 'chats'
      this.activeTopic = null

      this.$nextTick(() => {
        const list = this.$refs.chatsScroll

        if (list) {
          list.scrollTop = this.chatsScrollTop
        }

        this.loadMoreChatsIfListIsShort()
      })
    },

    goToMessages() {
      this.mobileStep = 'messages'
      this.desktopStep = 'messages'
    },

    goToTopics() {
      if (!this.activeChatIsForum) {
        return
      }
      this.mobileStep = 'topics'
      this.desktopStep = 'topics'
    },
  },
}
</script>
